import { DIFFS_ENDPOINT } from "../../constants";
import { compareIssueOverrides } from "../../utils";
import { baseApi } from "./base.api.required.stub";
export const diffApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getDiffSummary: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/summary`,
            }),
            transformResponse: (data) => {
                if (!data)
                    return data;
                return {
                    ...data,
                    issues: data.issues.map((issue) => ({
                        ...issue,
                        overrides: issue.overrides.toSorted(compareIssueOverrides),
                    })),
                };
            },
        }),
        getIssuesDiff: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/issues`,
                params: data,
            }),
        }),
        getIssuesDiffSources: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/issues/${data.ui_item_id}/files`,
                params: data,
            }),
        }),
        getThreatHuntingDetails: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.diffId}/hunting/${data.issueId}/files`,
            }),
        }),
        getSingleFileDiff: build.query({
            // matchFulfilled only fires on real fetches, not cache hits. Without keepUnusedDataFor=0,
            // extraReducer matchers (e.g. auto-expand on single-match filters) silently
            // skip on re-navigation because RTK Query serves cached data instead of fetching.
            keepUnusedDataFor: 0,
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/files/${data.ui_item_id}`,
                params: data,
            }),
        }),
        getFilesDiff: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/files`,
                params: data,
            }),
        }),
        getFileDiffDetails: build.query({
            query: (data) => ({
                url: `${DIFFS_ENDPOINT}/${data.ui_id}/files/${data.ui_item_id}/details`,
                params: data,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetDiffSummaryQuery, useGetIssuesDiffQuery, useGetIssuesDiffSourcesQuery, useGetThreatHuntingDetailsQuery, useGetSingleFileDiffQuery, useGetFilesDiffQuery, useGetFileDiffDetailsQuery, } = diffApi;
//# sourceMappingURL=diff.api.js.map